import { columnSettings, tableWidth } from "./report-template-setting";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateTableHeader = () => {
  return (
    <tr
      id="report-column-header"
      className={`row-start-start ${tableWidth} text-sm bg-zinc-100 font-semibold text-slate-800 `}
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border  px-2 h-full pb-2 pt-3 `}
      >
        {settings["no"].name}
      </td>

      <td
        className={`${settings["service_nama"].layout} ${settings["service_nama"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["service_nama"].name}
      </td>

      <td
        className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["speedo_akhir"].name}
      </td>

      <td
        className={`${settings["next"].layout} ${settings["next"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["next"].name}
      </td>

      <td
        className={`${settings["selisih"].layout} ${settings["selisih"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["selisih"].name}
      </td>

      <td
        className={`${settings["tanggal_terakhir_service"].layout} ${settings["tanggal_terakhir_service"].width} border-zinc-300 border border-l-0 px-2 h-full pb-2 pt-3 `}
      >
        {settings["tanggal_terakhir_service"].name}
      </td>
    </tr>
  );
};

export default ReportTemplateTableHeader;
